<template>
	<div class="certificate-edit">
		<b-card-group deck>
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
					<span class="hide-print">
						<h5>{{$t('certificate.editTitle')}}</h5>
					</span>
					<b-button variant="outline" @click.prevent="closeEditSidebar" class="hide-print">
						<i class="fa fa-close"></i>
					</b-button>
				</div>
				<b-form>
					<div class="btn-frame">
						<b-button variant="outline-info" class="hide-print" @click.prevent="printFunc">
							<i class="fa fa-print"></i> &nbsp;
							<span>{{$t('pricing.print')}}</span>
						</b-button>
					</div>
					<!--<div class="top-form">-->
						<!--<b-container fluid>-->
							<!--<b-row class="my-1">-->
								<!--<b-col sm="3">-->
									<!--&lt;!&ndash;<label for="input-small">{{$t('pricing.registrationNo')}}</label>&ndash;&gt;-->
									<!--&lt;!&ndash;<b-input-group&ndash;&gt;-->
										<!--&lt;!&ndash;size="sm"&ndash;&gt;-->
										<!--&lt;!&ndash;class="mb-3"&ndash;&gt;-->
									<!--&lt;!&ndash;&gt;&ndash;&gt;-->
										<!--&lt;!&ndash;<b-form-input&ndash;&gt;-->
											<!--&lt;!&ndash;:placeholder="$t('pricing.registrationNo')"&ndash;&gt;-->
											<!--&lt;!&ndash;:state="isValid"&ndash;&gt;-->
											<!--&lt;!&ndash;:value="this.items.costNumber"&ndash;&gt;-->
											<!--&lt;!&ndash;disabled&ndash;&gt;-->
											<!--&lt;!&ndash;class="noborder-print"&ndash;&gt;-->
										<!--&lt;!&ndash;&gt;&ndash;&gt;-->
										<!--&lt;!&ndash;</b-form-input>&ndash;&gt;-->
										<!--&lt;!&ndash;<b-input-group-append>&ndash;&gt;-->
											<!--&lt;!&ndash;<b-button&ndash;&gt;-->
												<!--&lt;!&ndash;size="sm"&ndash;&gt;-->
												<!--&lt;!&ndash;text="Button"&ndash;&gt;-->
												<!--&lt;!&ndash;class="hide-print"&ndash;&gt;-->
												<!--&lt;!&ndash;variant="success"&ndash;&gt;-->
												<!--&lt;!&ndash;disabled&ndash;&gt;-->
											<!--&lt;!&ndash;&gt;&ndash;&gt;-->
												<!--&lt;!&ndash;<i class="fa fa-refresh"></i>&ndash;&gt;-->
											<!--&lt;!&ndash;</b-button>&ndash;&gt;-->
										<!--&lt;!&ndash;</b-input-group-append>&ndash;&gt;-->
									<!--&lt;!&ndash;</b-input-group>&ndash;&gt;-->
								<!--</b-col>-->
							<!--</b-row>-->
						<!--</b-container>-->
					<!--</div>-->
					<b-table class="generalTableClass print-size" hover="hover" striped="striped" bordered="bordered"
							 small="small"
							 fixed="fixed"
							 :items="items"
							 responsive="sm" :fields="computedFields">

						<template slot="id" slot-scope="data">
							<strong>{{ data.item.id }}</strong>
						</template>
						<template slot="departmentName" slot-scope="data">
							<div v-for="(department,index) in data.item.departmentName">
								<em>{{index + 1}}</em>. {{department}}
							</div>
						</template>
						<template slot="value" slot-scope="data">
							{{ data.item.value }} {{ data.item.type ==='PERCENT' ? '%' : '' }}
						</template>
					</b-table>
					<nav>
						<b-pagination
							size="sm"
							:total-rows="items.total"
							:per-page="perPage"
							v-model="currentPage"
							:prev-text="$t('pagination.prev')"
							:next-text="$t('pagination.next')"
							hide-goto-end-buttons
						/>
					</nav>
				</b-form>
			</b-card>
		</b-card-group>
	</div>
</template>
<script>
	import {mapActions, mapGetters} from "vuex";
	import MaskedInput from 'vue-masked-input'
	import Multiselect from 'vue-multiselect'
	export default{
		data(){
			return{
				filter:false,
				currentPage: 1,
				perPage: 20,
				items:[]
			}
		},
		watch:{
			getEditCertificate:{
				handler(){
					this.items = this.getEditCertificate.items
				}
			}
		},
		computed:{
			...mapGetters('certificates', [
				'getCertificates','getEditCertificate'
			]),
			computedFields() {
				return [
					{
						key: 'id',
						label: this.$t('users-l.Id'),
						'class': 'role_id',
						sortable: true
					},
					{
						key:'certificateNumber',
						label:this.$t('certificate.number')
					},
					{
						key:'date',
						label:this.$t('certificate.expirationDate')
					},
					{
						key:'departmentName',
						label:this.$t('certificate.departmentName')
					},
					{
						key:'type',
						label:this.$t('certificate.typeList')
					},
					{
						key:'value',
						label:this.$t('certificate.mountPERCENTMONEY')
					}
				]
			},
		},
		async mounted(){
			let data={
				page: this.currentPage,
				limit: this.perPage,
			}
			await this.getEditCertificateList(data)
		},
		methods:{
			...mapActions('certificates', [
				'getCertificateList','getEditCertificateList'
			]),
			printFunc(){
				window.print();
			},
			closeEditSidebar(){
				this.$emit('closeEditSidebar')
			}
		}
	}
</script>
<style scoped>
	@media print {
		.card-header,.btn-frame,.pagination{
			display: none !important;
		}
		.b-table.table thead tr th[aria-sort]::after,.b-table.table tfoot tr th[aria-sort]::after {
			display: none !important;
		}
	}
	.btn-frame{
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;
	}
	.top-card{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>
